import axios from 'axios'

export const createTag = async (tagLabel: string) => {
  const data = await axios.post('/tag', { label: tagLabel })
  return data
}
